// Sidebar widths, whether the desktop sidebar is collapsed to its icon rail,
// and which navigation groups the user left open. Kept out of Sidebar.tsx so
// that file exports only its component (react-refresh/only-export-components).

export const SIDEBAR_WIDTH = 280;
export const SIDEBAR_COLLAPSED_WIDTH = 64;

const COLLAPSED_KEY = 'sidebar_collapsed';
const OPEN_GROUPS_KEY = 'sidebar_open_groups';

/** Whether the desktop sidebar was left collapsed; false when storage is unavailable. */
export function readSidebarCollapsed(): boolean {
  try {
    return localStorage.getItem(COLLAPSED_KEY) === '1';
  } catch {
    return false;
  }
}

export function writeSidebarCollapsed(collapsed: boolean): void {
  try {
    localStorage.setItem(COLLAPSED_KEY, collapsed ? '1' : '0');
  } catch {
    // Private mode or blocked storage: the choice is simply not remembered.
  }
}

/** Keys of the groups left open; empty (every group collapsed) when nothing is stored or storage is unavailable. */
export function readOpenGroups(): Set<string> {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(OPEN_GROUPS_KEY) ?? '[]');
    return new Set(Array.isArray(parsed) ? parsed.filter((k): k is string => typeof k === 'string') : []);
  } catch {
    return new Set();
  }
}

export function writeOpenGroups(open: ReadonlySet<string>): void {
  try {
    localStorage.setItem(OPEN_GROUPS_KEY, JSON.stringify([...open]));
  } catch {
    // Same as above: not remembered.
  }
}
